<template>
  <div>
    <div
      v-for="dfCategoryItem in dfCategoryItems"
      :key="dfCategoryItem.value"
      class="category-item"
    >
      <CategoryOptions
        :dfDefinitionCode="dfDefinitionCode"
        :dfCategoryNo="dfCategoryItem.value"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { request } from '@/api/service'
import CategoryOptions from '../category-options'
export default {
  components: { CategoryOptions },
  mixins: [],
  props: {
    dfDefinitionCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { dfCategoryItems: [] }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'dfDefinitionCategory' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.dfCategoryItems = lodash.sortBy(data, ['value'])
    },
  },
}
</script>

<style lang="scss" scoped>
.category-item {
  margin-bottom: 20px;
}
.category-item:last-child {
  margin-bottom: 0;
}
</style>
